import { Icon } from '@zet/design-system/index'
import { Stack, XStack } from '@zet/design-system/layout'
import { B2, SH3 } from '@zet/design-system/typography'
import { useBrandDetailsById } from '@zet/feature-brands/api/brands/hooks'
import { i18n } from '@zet/localization'
import { ScrollView } from 'react-native-gesture-handler'

const BrandTermsCondition = ({ brandId }: { brandId: string | number }) => {
  const { data: content } = useBrandDetailsById(brandId || '')

  return (
    <Stack className="mt-3 pl-3">
      <XStack className="mb-2">
        <Icon type="AnnounceOutlined" size={28} />
        <SH3>{i18n.t('brandDetails.termsHeading')}</SH3>
      </XStack>
      <ScrollView horizontal={true} showsHorizontalScrollIndicator={false}>
        {content?.importantTermsAndConditions.map(
          (value: string, index: number) => (
            <Stack
              className="bg-grays-20 mr-3 w-[250] rounded px-3 py-2"
              key={index}
            >
              <B2 className="text-grays-60">{value}</B2>
            </Stack>
          )
        )}
      </ScrollView>
      <Stack className="mt-3 h-[10] bg-white"></Stack>
    </Stack>
  )
}

export default BrandTermsCondition
